import { render } from "./BbScoreboard.vue?vue&type=template&id=38312bad&scoped=true"
import script from "./BbScoreboard.vue?vue&type=script&lang=js"
export * from "./BbScoreboard.vue?vue&type=script&lang=js"

import "./BbScoreboard.vue?vue&type=style&index=0&id=38312bad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38312bad"]])

export default __exports__